import type { ReactNode } from 'react';

interface CustomerPageHeaderProps {
  title: string;
  subtitle?: string;
  /** Small uppercase context line above the title (e.g. a count or section). */
  eyebrow?: string;
  actions?: ReactNode;
}

export function CustomerPageHeader({ title, subtitle, eyebrow, actions }: CustomerPageHeaderProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-customer-primary-text">
            {eyebrow}
          </p>
        )}
        <h1 className="text-xl font-semibold leading-tight tracking-tight text-customer-text sm:text-2xl">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-customer-text-secondary">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
